import Form from 'react-bootstrap/Form';

function FundingsStatusFilterForm({ statusFilter, changeStatusFilter, spinner }) {
  return (
    <Form.Select
      className="bo-filter"
      name="statusFilter"
      id="statusFilter"
      disabled={spinner}
      value={statusFilter}
      onChange={e => changeStatusFilter('fundings', e.target.value)}
    >
      <option value="">All Statuses</option>
      <option value="OPEN,DUE,CLOSING">All Open</option>
      <option value="OPEN">Open</option>
      <option value="DUE">Due</option>
      <option value="DEFAULT">Default</option>
      <option value="CLOSING">Closing</option>
      <option value="CLOSED">Closed</option>
      <option value="CANCELLED">Cancelled</option>
    </Form.Select>
  );
}

export default FundingsStatusFilterForm;
